/**
 * The product name, in one place. Renaming the product is a one-line change
 * here; <Logo /> is the only component that renders it as a wordmark.
 */
export const BRAND_NAME = 'FinCreator'
